import React, { useState } from "react";

const InputField = ({
  label,
  name,
  placeholder,
  value,
  onChange,
  step,
  type = "text",
  readOnly,
  maxLength = 0,
  required = true,
}) => {
  const [touched, setTouched] = useState(false);

  const handleChange = (event) => {
    const { value } = event.target;
    if (maxLength === 0 || value.length <= maxLength) {
      onChange(event);
    }
  };

  const handleBlur = () => {
    setTouched(true);
  };

  // Determine if field should show an error
  const showError = required && touched && !value?.trim();
  const errorMessage = showError ? "This field is required" : "";

  return (
    <div>
      <label className="block text-base font-medium text-gray-700 my-1">
        {label}
        {required && <span className="text-[14px] text-[#E72848]">*</span>}
      </label>

      <input
        name={name}
        type={type}
        step={step}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        readOnly={readOnly}
        className={`w-full border rounded-xl px-3 py-2 shadow-[0px_1px_2px_0px_#0A0D120D] focus:outline-none focus:ring-1 hover:ring-1
          ${showError
            ? "border-red-500 focus:ring-red-500 hover:ring-red-500"
            : "border-[#D5D7DA] focus:ring-[#E72848] hover:ring-[#E72848]"
          }`}
      />

      {showError && (
        <p className="text-sm text-red-600 mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default InputField;
